import $ from 'jquery';

$(function () {
    if ($('#embed_code_page').length) {
        $(document).ready(function () {
            $("#divIframe").hide();
            $("#divWidget").show();
            $("#divSearch").hide();
            $("#divLO").hide();

            $('.collapse-details').toggle();
            $('.collapse-title').click(function () { $('.collapse-details').toggle(); });
        });

        $('input[type=radio][name=LOInfo]').on('change', function () {
            switch ($(this).val()) {
                case 'Yes':

                    $("#divSearch").show();
                    $("#divLO").show();
                    break;
                case 'No':
                    $("#divSearch").hide();
                    $("#divLO").hide();
                    break;
            }
        });

        $('input[type=radio][name=code]').on('change', function () {
            switch ($(this).val()) {
                case 'widget':

                    $("#divIframe").hide();
                    $("#divWidget").show();
                    break;
                case 'iframe':
                    $("#divIframe").show();
                    $("#divWidget").hide();
                    break;
            }
        });

        $(document).on('change', 'input[name=loselect]', function () {
            var optionslist = $('datalist')[0].options;

            var value = $(this).val();

            for (var x = 0; x < optionslist.length; x++) {
                if (optionslist[x].value === value) {
                    var m = optionslist[x].getAttribute('data-details');
                    var c = optionslist[x].getAttribute('data-com');
                    var obj = JSON.parse(m);

                    $('input[name=loselect]').val(value);
                    $('input[name=LOFirstName]').val(obj["FirstName"]);
                    $('input[name=LOLastName]').val(obj["LastName"]);
                    $('input[name=LOTitle]').val(obj["Title"]);
                    $('input[name=LONMLS]').val(obj["Nmls"]);
                    $('input[name=LOCity]').val(obj["City"]);
                    $('input[name=LOState]').val(obj["State"]);
                    $('input[name=LOEmail]').val(obj["CorporateEmail"]);
                    $('input[name=LOPhone]').val(obj["Phone"]);
                    $('input[name=LOApplyNow]').val(obj["ApplyOnlineUrl"]);
                    $('input[name=LOImage]').val(obj["PortraitUrl"]);
                    $('input[name=LOMysite]').val(obj["MySitePath"]);
                    $('input[name=LOCompanyID]').val(c);
                    $('input[name=LOLogo]').val("https://cloud.cmgfi.com/dvbdysuf5/image/upload/AIOWebsite/Shared_Images/cmg-aio-logo.svg");

                    break;
                }
            }
        });

        window.copyToClipboard = function () {
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($("#hdn").val()).select();
            document.execCommand("copy");
            $temp.remove();
            alert("Copied Widget Code");
        }
        window.copyToClipboardIframe = function () {
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($("#hdnIframe").val()).select();
            document.execCommand("copy");
            $temp.remove();
            alert("Copied Iframe Code");
        }
    }
});
